import React from 'react';
import PropTypes from 'prop-types';
import { track } from '../../modules/tracking';

/**
 * The Nando’s menu logo. The logo itself is an SVG in css. This could potentially be replaced with the existing Link component.
 *
 * @function
 * @param       {String} href              Should contain a link to the href target of the initial anchor.
 * @param       {string} text              The text of the link.
 * @param       {string} title             A slightly longer descriptive text for the title attribute of the link.
 * @param       {string} className         An optional class to add to the existing component class attribute.
 * @constructor
 */
function LogoLink({ href, text, title, className }) {
    return (
        <h1 className={className}>
            <a
                onClick={track('Top navigation: Click: Barci')}
                href={href}
                title={title}
            >
                {text}
            </a>
        </h1>
    );
}

LogoLink.propTypes = {
    href: PropTypes.string,
    text: PropTypes.string,
    title: PropTypes.string,
    className: PropTypes.string
};

export { LogoLink };
